import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
import Layout from '@/layout/Layout'

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/home'
    },


    {
      path: '/login',
      component: () => import('@/views/login/index'),
      name: 'login',
      title: '登录'
    },

    {
      path: '/home',
      component: Layout,
      children: [{
        path: '',
        component: () => import('@/views/home/home'),
        name: 'home',
        title: '首页'
      }]
    },
    {
      path: '/mine',
      component: Layout,
      children: [{
        path: '',
        component: () => import('@/views/mine/index'),
        name: 'mine',
        title: '我的'
      }]
    },
    {
      path: '/payee',
      component: () => import('@/views/mine/payee'),
      name: 'payee',
      title: '收款人'
    },
    {
      path: '/refund',
      component: () => import('@/views/mine/refund'),
      name: 'refund',
      title: '退款账户'
    },
    {
      path: '/idno',
      component: () => import('@/views/idno/index'),
      name: 'idno',
      title: '身份认证'
    },
    {
      path: '/base',
      component: () => import('@/views/idno/base'),
      name: 'base',
      title: '基础信息'
    },
    {
      path: '/idnoInfo',
      component: () => import('@/views/idno/idnoinfo'),
      name: 'idnoInfo',
      title: '认证信息'
    },
    {
      path: '/idnoinfotwo',
      component: () => import('@/views/idno/idnoinfotwo'),
      name: 'idnoinfotwo',
      title: '证件信息'
    },
    {
      path: '/accinfo',
      component: () => import('@/views/mine/accinfo'),
      name: 'accinfo',
      title: '账户信息'
    },
    {
      path: '/transfer',
      component: () => import('@/views/transfer/index'),
      name: 'transfer',
      title: '汇款信息确定'
    },
    {
      path: '/initiate',
      component: () => import('@/views/transfer/initiate'),
      name: 'initiate',
      title: '发起转账'
    },
    {
      path: '/bill',
      component: () => import('@/views/mine/bill'),
      name: 'bill',
      title: '汇款记录'
    },
    {
      path: '/billcancel',
      component: () => import('@/views/mine/billcancel'),
      name: 'billcancel',
      title: '选择取消原因'
    },
    {
      path: '/guide',
      component: () => import('@/views/mine/guide'),
      name: 'guide',
      title: 'guide'
    },
    {
      path: '/logout',
      component: Layout,
      children: [{
        path: '',
        component: () => import('@/views/logout/index'),
        name: 'logout',
        title: 'logout'
      }
      ]
    },
    {
      path: '/loginValidate',
      component: () => import('@/views/login/loginValidate'),
      name: 'loginValidate',
      title: '验证'
    },
    {
      path: '/loginSetPW',
      component: () => import('@/views/login/loginSetPW'),
      name: 'loginSetPW',
      title: '设置登录密码'
    },
    {
      path: '/loginPW',
      component: () => import('@/views/login/loginPW'),
      name: 'loginPW',
      title: '设置登录密码'
    },
    {
      path: '/receive',
      component: () => import('@/views/receive/index'),
      name: 'receive',
      title: '身份认证'
    },
    {
      path: '/receivebase',
      component: () => import('@/views/receive/base'),
      name: 'receivebase',
      title: '基础信息'
    },
    {
      path: '/receiveidnoInfo',
      component: () => import('@/views/receive/idnoinfo'),
      name: 'receiveidnoInfo',
      title: '认证信息'
    },
    {
      path: '/billDetail',
      component: () => import('@/views/mine/billDetail'),
      name: 'billDetail',
      title: '汇款详情'
    },
    {
      path: '/account',
      component: () => import('@/views/mine/account'),
      name: 'account',
      title: '账户管理'
    },
    {
      path: '/changetie',
      component: () => import('@/views/mine/changetie'),
      name: 'changetie',
      title: '换绑手机号'
    },
    {
      path: '/changeaccount',
      component: () => import('@/views/mine/changeaccount'),
      name: 'changeaccount',
      title: '更换新账号'
    },
    {
      path: '/newaccount',
      component: () => import('@/views/mine/newaccount'),
      name: 'changeaccount',
      title: '绑定新账号'
    },
    {
      path: '/PrivacyPolicy',
      component: () => import('@/views/home/PrivacyPolicy'),
      name: 'PrivacyPolicy',
      title: '隐私政策'
    },
    {
      path: '/tips',
      component: () => import('@/views/home/tips'),
      name: 'tips',
      title: '提示页面'
    },
    {
      path: '/ArrivalTime',
      component: () => import('@/views/home/ArrivalTime'),
      name: 'ArrivalTime',
      title: '到账时间说明'
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js